"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M4.257 19.744c4.27 4.27 11.217 4.27 15.488 0a10.89 10.89 0 0 0 2.043-2.848h-5.525a2.165 2.165 0 0 1-2.026-1.406A2.344 2.344 0 0 0 12 13.896c-.533 0-1.034.176-1.437.482a2.35 2.35 0 0 0-.807 1.132 2.16 2.16 0 0 1-2.018 1.386H2.213a10.89 10.89 0 0 0 2.044 2.848Zm.045-10.375a.554.554 0 0 1 .777-.095l5.123 4.01A3.49 3.49 0 0 1 12 12.79c1.499 0 2.82.945 3.282 2.332.148.393.55.667.98.667h6.001a10.97 10.97 0 0 0 .657-3.234h-2.63a.554.554 0 0 1 0-1.107h2.631a10.89 10.89 0 0 0-2.803-6.779L18.234 6.55a.556.556 0 0 1-.784 0 .554.554 0 0 1 0-.783l1.883-1.883a10.892 10.892 0 0 0-6.778-2.804v2.631a.555.555 0 0 1-1.108 0v-2.63a10.885 10.885 0 0 0-6.778 2.804L6.47 5.687a.554.554 0 1 1-.783.784L3.885 4.668a10.89 10.89 0 0 0-2.804 6.779h2.63a.553.553 0 1 1 0 1.107h-2.63c.055 1.1.273 2.19.657 3.234h6c.43 0 .833-.274.973-.648.141-.42.356-.798.63-1.122l-4.944-3.871a.552.552 0 0 1-.095-.778ZM.077 12.266A.542.542 0 0 1 0 12c0-.098.033-.186.077-.267a11.889 11.889 0 0 1 3.48-8.174v-.002l.002-.002A11.89 11.89 0 0 1 11.734.078.536.536 0 0 1 12 0c.1 0 .186.032.267.078a11.887 11.887 0 0 1 8.177 3.479 11.887 11.887 0 0 1 3.479 8.178A.53.53 0 0 1 24 12a.527.527 0 0 1-.077.265 11.935 11.935 0 0 1-.797 4.049c0 .01.006.019.006.027a.548.548 0 0 1-.187.41 11.868 11.868 0 0 1-2.5 3.693A11.9 11.9 0 0 1 12 23.935a11.9 11.9 0 0 1-8.443-3.491 11.862 11.862 0 0 1-2.5-3.692.545.545 0 0 1-.189-.41c0-.01.006-.02.006-.03-.502-1.3-.765-2.67-.797-4.046Z",
    clipRule: "evenodd"
  })]
});